import {
  BarChart,
  Bar,
  PieChart,
  Pie,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { Card } from "../common/Card";
import { ErrorRetry } from "../../common/ErrorRetry";
import { DailyRevenueShimmer } from "../../common/reportDashBShimmer/DailyRevenueShimmer";
import { PieChartShimmer } from "../../common/reportDashBShimmer/PieChartShimmer";
import { REPORT_SUMMARY_COLORS } from "./reportSummaryUtils";

export function ReportSummaryRevenueOverviewSection({
  flightSummaryState,
  categoryState,
  dailyRevenue,
  categoryData,
}) {
  return (
    <div>
      <span className="mb-4 text-2xl text-[#1A1A1A]">Revenue Overview</span>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card className="p-6 bg-white rounded-lg shadow-sm border border-gray-100">
          <span className="mb-6 text-xl text-[#1A1A1A]">Daily Revenue</span>

          {flightSummaryState.loading ? (
            <DailyRevenueShimmer />
          ) : flightSummaryState.error ? (
            <div className="h-[350px] flex items-center justify-center">
              <ErrorRetry
                message={flightSummaryState.message}
                onRetry={flightSummaryState.onRetry}
              />
            </div>
          ) : dailyRevenue.length > 0 ? (
            <ResponsiveContainer width="100%" height={350}>
              <BarChart data={dailyRevenue}>
                <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />
                <XAxis dataKey="day" stroke="#6B7280" />
                <YAxis stroke="#6B7280" />
                <Tooltip
                  contentStyle={{
                    backgroundColor: "white",
                    border: "1px solid #E5E7EB",
                    borderRadius: "8px",
                  }}
                  formatter={(value) => `₦${value.toLocaleString()}`}
                />
                <Legend />
                <Bar
                  dataKey="revenue"
                  fill="#1E61DC"
                  radius={[8, 8, 0, 0]}
                  name="Revenue (₦)"
                />
              </BarChart>
            </ResponsiveContainer>
          ) : (
            <div className="h-[350px] flex items-center justify-center text-gray-500">
              No revenue data available
            </div>
          )}
        </Card>

        {categoryState.loading ? (
          <PieChartShimmer />
        ) : categoryData.length > 0 ? (
          <Card className="p-6 bg-white rounded-lg shadow-sm border border-gray-100">
            <span className="mb-6 text-xl text-[#1A1A1A]">
              Revenue by Product
            </span>
            <ResponsiveContainer width="100%" height={350}>
              <PieChart>
                <Pie
                  data={categoryData}
                  cx="50%"
                  cy="50%"
                  innerRadius={70}
                  outerRadius={120}
                  paddingAngle={2}
                  dataKey="revenue"
                  label={({ category, sharePercentage }) =>
                    `${category} ${sharePercentage}%`
                  }
                >
                  {categoryData.map((entry, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={
                        REPORT_SUMMARY_COLORS[
                          index % REPORT_SUMMARY_COLORS.length
                        ]
                      }
                    />
                  ))}
                </Pie>
                <Tooltip
                  contentStyle={{
                    backgroundColor: "white",
                    border: "1px solid #E5E7EB",
                    borderRadius: "8px",
                  }}
                  formatter={(revenue) => `₦${revenue.toLocaleString()}`}
                />
              </PieChart>
            </ResponsiveContainer>
          </Card>
        ) : (
          <Card className="p-6 bg-white rounded-lg shadow-sm border border-gray-100">
            <div
              className={`h-[350px] flex items-center justify-center ${
                categoryState.error ? "text-red-500" : "text-gray-500"
              }`}
            >
              {categoryState.error ? (
                <ErrorRetry
                  message={categoryState.message}
                  onRetry={categoryState.onRetry}
                />
              ) : (
                "No revenue data available"
              )}
            </div>
          </Card>
        )}
      </div>
    </div>
  );
}
